export default __webpack_public_path__ + "static/media/SemanaNordica_Agenda_Miercoles_Banner.feba2e82.png";